import * as angular from "angular";
import {IController} from "angular";

export class resourceAllocationItemCtrl implements IController {

  allocation: any;

  private hours: any;

  /* @ngInject */
  constructor(private moment) {
  }

  $onInit() {
    var duration = this.moment.duration(
      this.moment(this.allocation.schedule.endTime).diff(this.moment(this.allocation.schedule.startTime))
    );
    this.hours = duration.asHours();
  };

  $onChanges(changes) {
    if (changes.allocation && !changes.allocation.isFirstChange()) {
      this.$onInit();
    }
  }

}

angular
  .module('bringoz.admin.resources')
  .component('resourceAllocationItem', {
    bindings: {
      allocation: '<'
    },
    template: require('./resource-allocation-item.html').default,
    controller: resourceAllocationItemCtrl
  });
